export const ObjectTypes = {
    BOOKING_EVENT: 'bookingevent',
    EVENT_TYPE: 'eventtype',
    CLIENT: 'client',
    BOOKABLE_RESOURCE: 'bookableresource',
    FORM_SUBMISSION: 'formsubmission',
    FORM: 'form',
    PACKAGE_GRANT: 'packagegrant',
    CLASS: 'class',
    GIFT_CERTIFICATE: 'giftcertificate',
    INVOICE: 'invoice',
};

export const ClassToObjectTypes = {
    'App\\Models\\BookingCalendarEvent': ObjectTypes.BOOKING_EVENT,
    'App\\Models\\EventType': ObjectTypes.EVENT_TYPE,
    'App\\Models\\Client': ObjectTypes.CLIENT,
    'App\\Models\\BookableResource': ObjectTypes.BOOKABLE_RESOURCE,
    'App\\Models\\FormSubmission': ObjectTypes.FORM_SUBMISSION,
    'App\\Models\\Form': ObjectTypes.FORM,
    'App\\Models\\PackageGrant': ObjectTypes.PACKAGE_GRANT,
    'App\\Models\\ClassInstance': ObjectTypes.CLASS,
};

export const ObjectTypeHumanNames = {
    [ObjectTypes.BOOKING_EVENT]: 'Events',
    [ObjectTypes.CLIENT]: 'Clients',
    [ObjectTypes.BOOKABLE_RESOURCE]: 'Bookable People/Resources',
    [ObjectTypes.FORM_SUBMISSION]: 'Form Submissions',
    [ObjectTypes.FORM]: 'Forms',
    [ObjectTypes.EVENT_TYPE]: 'Event Type',
    [ObjectTypes.CLASS]: 'Class',
    [ObjectTypes.INVOICE]: 'Invoice',
};

export const ObjectTypeSingularNames = {
    [ObjectTypes.BOOKING_EVENT]: 'event',
    [ObjectTypes.EVENT_TYPE]: 'event type',
    [ObjectTypes.CLIENT]: 'client',
    [ObjectTypes.BOOKABLE_RESOURCE]: 'person/resource',
    [ObjectTypes.FORM_SUBMISSION]: 'form submission',
    [ObjectTypes.FORM]: 'form',
    [ObjectTypes.PACKAGE_GRANT]: 'package',
    [ObjectTypes.CLASS]: 'class',
    [ObjectTypes.GIFT_CERTIFICATE]: 'gift certificate',
    [ObjectTypes.INVOICE]: 'invoice',
};

export function humanSingularObjectName(type) {
    return ObjectTypeSingularNames[type] ?? type;
}
